import sanitizeHtml from "sanitize-html";
import { DEFAULT_OPEN_GRAPH_LOCALES_BY_LANGUAGE } from "../internationalization/locales/open-graph";
import { decodeHtmlEntities } from "./string";
export const OPEN_GRAPH_IMAGE_WIDTH = 1200;
export const OPEN_GRAPH_IMAGE_HEIGHT = 630;
export const OPEN_GRAPH_DESCRIPTION_MAX_LENGTH = 160;
export const OPEN_GRAPH_IMAGE_MIME_TYPE = "image/jpeg";
const CLOUDINARY_UPLOAD_SEGMENT = "/image/upload/";
const COVER_TRANSFORMATION = `c_fill,g_auto,f_jpg,q_auto,w_${OPEN_GRAPH_IMAGE_WIDTH},h_${OPEN_GRAPH_IMAGE_HEIGHT}`;
const CONTAIN_TRANSFORMATION = `c_pad,b_auto,f_jpg,q_auto,w_${OPEN_GRAPH_IMAGE_WIDTH},h_${OPEN_GRAPH_IMAGE_HEIGHT}`;
export function getOpenGraphImage(url, options = {}) {
    if (!url) {
        return null;
    }
    const transformation = options.fit === "contain" ? CONTAIN_TRANSFORMATION : COVER_TRANSFORMATION;
    const uploadIndex = url.indexOf(CLOUDINARY_UPLOAD_SEGMENT);
    if (!url.includes("res.cloudinary.com") || uploadIndex === -1) {
        return { url };
    }
    if (url.includes(transformation)) {
        return {
            url,
            width: OPEN_GRAPH_IMAGE_WIDTH,
            height: OPEN_GRAPH_IMAGE_HEIGHT,
            mimeType: OPEN_GRAPH_IMAGE_MIME_TYPE,
        };
    }
    const insertAt = uploadIndex + CLOUDINARY_UPLOAD_SEGMENT.length;
    return {
        url: `${url.slice(0, insertAt)}${transformation}/${url.slice(insertAt)}`,
        width: OPEN_GRAPH_IMAGE_WIDTH,
        height: OPEN_GRAPH_IMAGE_HEIGHT,
        mimeType: OPEN_GRAPH_IMAGE_MIME_TYPE,
    };
}
function truncateAtWordBoundary(text, maxLength) {
    if (text.length <= maxLength) {
        return text;
    }
    const slice = text.slice(0, maxLength - 1);
    const lastSpaceIndex = slice.lastIndexOf(" ");
    const truncated = lastSpaceIndex > 0 ? slice.slice(0, lastSpaceIndex) : slice;
    return `${truncated.trimEnd()}…`;
}
export function getOpenGraphDescription(input) {
    if (!input) {
        return "";
    }
    const withoutTags = sanitizeHtml(input, { allowedTags: [] });
    const decoded = decodeHtmlEntities(withoutTags);
    const normalized = decoded.replace(/[\s\u00A0]+/g, " ").trim();
    return truncateAtWordBoundary(normalized, OPEN_GRAPH_DESCRIPTION_MAX_LENGTH);
}
export function getOpenGraphLocale(isoLocale) {
    if (!isoLocale) {
        return "en_US";
    }
    if (isoLocale.includes("-")) {
        const [language, region] = isoLocale.split("-");
        return `${language.toLowerCase()}_${region.toUpperCase()}`;
    }
    return DEFAULT_OPEN_GRAPH_LOCALES_BY_LANGUAGE[isoLocale.toLowerCase()] ?? "en_US";
}
